module.exports = __webpack_public_path__ + "static/media/DSC_0323.60f026b2.jpg";